import RemoveGroupButton from './RemoveGroupButton';

export default RemoveGroupButton;
